import { styled } from "styled-components";

import { Button } from "../Button";
import { Image } from "../Image";

export const CARD_WIDTH = 246;

export const Container = styled.div(({ theme }) => {
  return {
    display: "inline-flex",
    flexDirection: "column",
    width: CARD_WIDTH,
    border: "1px solid #f1f1f1",
    borderRadius: theme.radii[2],
    boxSizing: "content-box",
    overflow: "hidden",
    backgroundColor: theme.colors.grayLight,

    [`& ${Image.Background.Base}`]: {
      height: 150,
    },

    [`& ${Button.Container}`]: {
      width: "100%",
      color: theme.colors.primary,
      backgroundColor: theme.colors.white,
      boxShadow: `0 5px 8px -8px ${theme.shadows[12]}, 0 2px 4px -3px ${theme.shadows[12]}, 0 0 0 1px ${theme.shadows[3]}, 0 1px 3px 1px ${theme.shadows[1]}`,
      marginBottom: theme.space[2],
      transition: "color 0.25s, box-shadow 0.25s",

      "&:hover": {
        color: theme.colors.primaryDark,
        backgroundColor: theme.colors.white,
        boxShadow: `0 5px 8px -8px ${theme.shadows[12]}, 0 2px 4px -3px ${theme.shadows[12]}, 0 0 0 1px ${theme.shadows[4]}, 0 1px 4px 1px ${theme.shadows[4]}`,
      },

      "&:first-of-type": {
        marginTop: theme.space[3],
      },

      "&:last-of-type": {
        marginBottom: 0,
      },
    },
  };
});

export const Content = styled.div(({ theme }) => {
  return {
    padding: theme.space[3],
  };
});

export const Header = styled.div(({ theme }) => {
  return {
    margin: `0 0 ${theme.space[1]} 0`,
    fontWeight: theme.fontWeights[2],
    color: theme.colors.black,
    whiteSpace: "break-spaces",
  };
});

/** Card description.
 * - `$lineClamp` - Number of lines to clamp the description to. Used by Availability cards */
export const Description = styled.p<{ $lineClamp?: string }>(
  ({ theme, $lineClamp }) => {
    const lineClampStyles = {
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": $lineClamp,
      overflow: "hidden",
    };
    return {
      margin: 0,
      fontSize: theme.fontSizes[1],
      color: theme.colors.grayDark,
      whiteSpace: "break-spaces",
      cursor: "pointer",
      ...($lineClamp ? lineClampStyles : {}),
    };
  },
);

export const Link = styled.a(({ theme }) => {
  return {
    margin: 0,
    fontSize: theme.fontSizes[1],
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "rgb(93, 157, 245)",
    textDecoration: "underline",
    textDecorationColor: "rgb(93, 157, 245)",
    pointerEvents: "all",
    wordBreak: "break-all",
  };
});
